<template>
  <section class="price-listing push-v--desktop--x-large push-v--tablet--large push-v--mobile--large">
    <div class="price-listing__intro-wrapper push-v--desktop--medium push-v--tablet--medium push-v--mobile--medium">
      <h2
          v-if="title"
          class="price-listing__title push-v--desktop--small push-v--tablet--x-small push-v--mobile--x-small"
      >
        {{ title }}
      </h2>
      <p class="price-listing__selected-stay">{{ shortStayFlag && shortStayFilterLabel ||longStayFlag && longStayFilterLabel }}</p>
      <div class="rooms-pricing-details__subtitle">
        {{ intro }}
      </div>

      <div class="mobile-tabs rooms-pricing-details__tabs">
        <div v-if="hasShortStayItems" class="faux-radio-wrapper" @click="showShort">
          <button
              class="btn--white faux-radio"
              :class="{ 'active-booking-type': shortStayFlag }"
          >
            <span class="inner-button" />
          </button>
          <span class="button-text">{{ shortStayFilterLabel }}</span>
        </div>
        <div v-if="hasLongStayItems" class="faux-radio-wrapper" @click="showLong">
          <button
              class="btn--white faux-radio"
              :class="{ 'active-booking-type': longStayFlag }"
          >
            <span class="inner-button" />
          </button>
          <span class="button-text">{{ longStayFilterLabel }}</span>
        </div>
      </div>
      <div class="desktop-tabs rooms-pricing-details__tabs">
        <div v-if="hasShortStayItems" class="faux-radio-wrapper" @click="showShort">
          <button
              class="btn--white faux-radio"
              :class="{ 'active-booking-type': shortStayFlag }"
          >
            <span class="inner-button" />
          </button>
          <span class="button-text">{{ shortStayFilterLabel }}</span>
        </div>

        <div v-if="hasLongStayItems" class="faux-radio-wrapper" @click="showLong">
          <button
              class="btn--white faux-radio"
              :class="{ 'active-booking-type': longStayFlag }"
          >
            <span class="inner-button" />
          </button>
          <span class="button-text">{{ longStayFilterLabel }}</span>
        </div>
      </div>
      <div class="price-listing__description">
        <div class="price-listing__features-title">
          All room features:
        </div>
        <ul class="price-listing__features-list">
          <li v-for="(item,index) in roomFeatures" :key="index">
            <img :src="item.icon.url">{{ item.feature }}
          </li>
        </ul>
      </div>
    </div>

    <div class="row price-listing__row">
      <!-- <div class="price-listing__description">
        <div class="price-listing__features-title">
          All room features:
        </div>
        <ul class="price-listing__features-list">
          <li v-for="(item,index) in roomFeatures" :key="index">
            <img :src="item.icon.url">{{ item.feature }}
          </li>
        </ul>
      </div> -->
      <div v-if="items" class="price-listing__horizontal-scroll-wrapper">
        <div class="price-listing__horizontal-scroll">
          <div v-for="(item, index) in items" :key="index" class="price-listing__item">
            <slot v-if="item.type[0].codename==='shortLongStay' || item.type[0].codename===bookingType" :item="item" name="item" />
          </div>
        </div>

        <div class="price-listing--carousel-scrollbar-wrapper">
          <div @click="scrollToLeftEnd">
            <arrow-icon class="price-listing--carousel-arrow price-listing--carousel-arrow-left hidden" />
          </div>
          <div class="price-listing--carousel-scrollbar">
            <div class="price-listing--carousel-dragger" />
          </div>
          <div @click="scrollToRightEnd">
            <arrow-icon class="price-listing--carousel-arrow price-listing--carousel-arrow-right withBounce" />
          </div>
        </div>
      </div>
    </div>
    <button v-if="showLoadMore">{{ loadMoreText }}</button>
  </section>
</template>

<script>

import ArrowIcon from '~/assets/icons/arrow-right-simple.svg?inline';
import debounce from 'lodash.debounce';

export default {
  components: {
    ArrowIcon,
  },
  props: {
    title: { type: String, default: '' },
    intro: { type: String, default: '' },
    triggerFilter: { type: Function, default: null },
    activeFilter: { type: String, default: '' },
    longStayDescription: { type: String, default: '' },
    shortStayDescription: { type: String, default: '' },
    shortStayFilterLabel: { type: String, default: '', required: false },
    longStayFilterLabel: { type: String, default: '', required: false },
    filters: {
      type: Array,
      default() {
        return [];
      },
    },
    items: {
      required: true,
      type: Array,
      default() {
        return [];
      },
    },
    showLoadMore: { type: Boolean, default: false },
    loadMoreText: { type: String, default: 'Load More' },
    roomFeatures: { type: Array, default() {
      return [
        { icon: '',
          feature: '',
        },
      ];
    } },
  },
  data() {
    return {
      hasShortStayItems: true,
      hasLongStayItems: true,
      longStayFlag: true,
      shortStayFlag: false,
      bookingType: 'longStay',
      pos: { top: 0, left: 0, x: 0, y: 0 },
      carousel: '',
      scrollPosition: 0,
      scrollbar: '',
      dragger: '',
      scrollbarWidth: 0,
    };
  },
  mounted() {
    this.carousel = document.querySelector('.price-listing__horizontal-scroll');
    this.debouncedResize = debounce(this.resizeHandler, 100);
    setTimeout(this.checkScrollbarVisibility, 500);

    if (this.carousel) {
      window.addEventListener('resize', this.debouncedResize);
      this.carousel.addEventListener('mousedown', this.mouseDownHandler);
      this.carousel.addEventListener('scroll', this.isScrolling);

    }
    this.dragger = document.querySelector('.price-listing--carousel-dragger');
    const scrollbar = document.querySelector('.price-listing--carousel-scrollbar');
    this.scrollbarWidth = scrollbar.clientWidth - this.dragger.clientWidth;
  },
  updated() {
    this.hasShortStayItems=this.items.some((item)=>['shortStay', 'shortLongStay'].includes(item.type[0].codename));
    this.hasLongStayItems=this.items.some((item)=>['longStay', 'shortLongStay'].includes(item.type[0].codename));

    !this.hasLongStayItems && this.showShort();
    !this.hasShortStayItems && this.showLong();
  },
  methods: {
    showLong() {
      this.longStayFlag = true;
      this.shortStayFlag = false;
      this.bookingType = 'longStay';
      this.triggerFilter('longStay');
      setTimeout(this.checkScrollbarVisibility, 500);
      this.scrollToLeftEnd();
    },
    showShort() {
      this.longStayFlag = false;
      this.shortStayFlag = true;
      this.bookingType = 'shortStay';
      this.triggerFilter('shortStay');
      setTimeout(this.checkScrollbarVisibility, 500);
      this.scrollToLeftEnd();
    },

    scrollToRightEnd() {
      const rightEdge = this.carousel.scrollWidth - this.carousel.clientWidth;
      this.carousel.scroll({
        left: rightEdge,
        top: 0,
        behavior: 'smooth',
      });

      this.scrolledToRight();
    },
    scrollToLeftEnd() {
      this.carousel.scroll({
        left: 0,
        top: 0,
        behavior: 'smooth',
      });
      this.scrolledToLeft();
    },


    scrolledToLeft() {
      document.querySelector(`.price-listing--carousel-arrow-right`).classList.remove('hidden');
      document.querySelector(`.price-listing--carousel-arrow-left`).classList.add('hidden');
    },
    scrolledToRight() {
      document.querySelector(`.price-listing--carousel-arrow-right`).classList.add('hidden');
      document.querySelector(`.price-listing--carousel-arrow-left`).classList.remove('hidden');
      document.querySelector(`.price-listing--carousel-arrow-right`).classList.remove('withBounce');
    },

    isScrolling(evt) {
      const scrollableDistance = this.carousel.scrollWidth-this.carousel.clientWidth;
      const currentPosition = this.carousel.scrollLeft;
      this.scrollPosition = currentPosition/scrollableDistance;
      const draggerPosition = this.scrollPosition*this.scrollbarWidth;
      this.dragger.style.left = `${draggerPosition}px`;


      if (this.carousel.scrollLeft<=0) {
        this.scrolledToLeft();
      }
      if (this.carousel.scrollLeft>=this.carousel.scrollWidth - this.carousel.clientWidth) {
        this.scrolledToRight();
      }
    },
    checkScrollbarVisibility() {
      const rightEdge = this.carousel.scrollWidth - this.carousel.clientWidth;
      if (rightEdge <= 0) {
        document.querySelector('.price-listing--carousel-scrollbar-wrapper').classList.add('hidden');
      } else {
        document.querySelector('.price-listing--carousel-scrollbar-wrapper').classList.remove('hidden');
      }
    },
    resizeHandler(e) {
      this.checkScrollbarVisibility();
    },
    mouseDownHandler(e) {
      // Change the cursor and prevent user from selecting the text
      this.carousel.style.cursor = 'grabbing';
      this.carousel.style.userSelect = 'none';

      this.pos = {
        left: this.carousel.scrollLeft,
        top: this.carousel.scrollTop,
        x: e.clientX,
        y: e.clientY,
      };

      document.addEventListener('mousemove', this.mouseMoveHandler);
      document.addEventListener('mouseup', this.mouseUpHandler);
    },
    mouseUpHandler() {
      this.carousel.style.cursor = 'grab';
      this.carousel.style.removeProperty('user-select');
      document.removeEventListener('mousemove', this.mouseMoveHandler);
    },
    mouseMoveHandler(e) {
      // How far the mouse has been moved
      const dx = e.clientX - this.pos.x;
      const dy = e.clientY - this.pos.y;

      // Scroll the element
      this.carousel.scrollTop = this.pos.top - dy;
      this.carousel.scrollLeft = this.pos.left - dx;
    },
  },
};
</script>

<style lang="scss">
@import '~/assets/scss/atomic/modules/_price-listing.scss';
</style>
